<div id="login-logo" class="text-center my-5">
    <img src="https://res.cloudinary.com/teammood/image/upload/c_scale,w_96/v1541855232/logo-1000px_transparent.png" alt="TeamMood">
</div>

<div id="login-container" class="mx-auto px-2 py-4">
    <h4 class="text-center pb-3">{{ 'login' | translate }}</h4>

    <div class="alert" [ngClass]="$safeNavigationMigration(message?.style)" [hidden]="!message?.text">
        {{message?.text}}
    </div>

    <form id="login-form" class="form-horizontal">
        <div class="form-group pb-3" [hidden]="!(show === 'email')">
            <label class="fw-bold pb-1" for="email">{{ 'email_address' | translate }}</label>
            <div class="input-group">
                <input type="text" class="form-control" id="email" name="email" [(ngModel)]="email" placeholder="Email.." value="" autofocus="">
                <span class="icon-addon"><i class="far fa-envelope"></i></span>
            </div>
        </div>

        <div class="form-group pb-3" [hidden]="!(show === 'password')">
            <div class="d-flex justify-content-between">
                <label class="fw-bold pb-1" for="password">{{ 'password.password1' | translate }}</label>
                <div><a href="/reset" title="Forgot pass?:">{{ 'resetPassword' | translate}}?</a></div>
            </div>
            <div class="input-group">
                <input type="password" [(ngModel)]="password" class="form-control" id="password" name="password" placeholder="Password">
                <span class="icon-addon"><i class="far fa-asterisk"></i></span>
            </div>
        </div>

        <div class="form-group pb-3" [hidden]="!(show === 'init_password')">
            <label for="password">{{ 'password.no_credentials_yet' | translate }}</label>
            <div class="input-group">
                <input type="text" disabled="true" class="form-control" id="init_password" name="password_init" placeholder="{{ 'password.first_login' | translate }}">
                <span class="icon-addon"><i class="far fa-asterisk"></i></span>
            </div>
        </div>

        <div class="form-group" [hidden]="!(show === 'password_initialized')">
            <label for="password">You will shortly receive an email with password initialization instructions.</label>
        </div>

        <div class="form-group pb-3 clearfix">
            <button class="btn btn-primary d-block w-100" (click)="main_button.action()"><span style="text-transform: capitalize;">{{ main_button.label }}</span>&nbsp;<i class="far fa-arrow-right"></i>
            </button>
        </div>
        @if(show === 'email'){
            <p>{{ 'no_account_yet' | translate }}<br><a href="https://app.teammood.com/signup">{{ 'signup_here' | translate }}</a></p>
        }@else {
            <p><a href="javascript:void(0)" (click)="begin_login()">{{ 'back' | translate }}</a></p>
        }
    </form>
</div>

<div id="footer">
    <div class="container text-center">
        <span id="year-copy"></span><span class="copyright"></span>TeamMood - {{'madeBy' | translate}} <strong><i class="far fa-heart"></i></strong>
        {{'in' | translate}} Toulouse, France - <a href="https://www.teammood.com/privacy-policy/" target="_blank">
        {{'privacy' | translate}}</a> - <a href="https://www.teammood.com/terms-of-service/" target="_blank">{{'terms_of_use'
        | translate}}</a>
    </div>
</div>
